import { Loader, ProgressBar } from "@adeccoux/tag-ds";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BaseContext } from "../../App";
import {
    useScreenTransition,
    useTimer,
    redirectToAssessmentSummary,
    useTimerValues,
} from "../../util/common";
import { saveAnswers } from "../../util/resources";
import SesHeader from "../header";
import WarmupComplete from "../instructions/warmupComplete";
import CompletePopUp from "./CompletePopup";
import TestTakerQuestions28 from "./testTakerQuestion28";
import TestTakerQuestions29 from "./testTakerQuestion29";

const MainTestTaker28 = ({ isWarmUp, testData, testId, sessionId }) => {
    const location = useLocation();
    const [questionData, setQuestionData] = useState(
        isWarmUp ? testData?.exapmleQuestionList : testData?.question
    );
    const [currentQuestion, setCurrentQuestion] = useState(
        isWarmUp ? testData?.exapmleQuestionList[0] : testData?.question[0]
    );
    const [isComplete, setComplete] = useState(false);
    const [currQuestNo, setCurrQuestNo] = useState(0);
    const [keyStroke, setKeyStroke] = useState(0);
    const navigate = useNavigate();
    const { min, sec, totalSecLeft, startTimer, stopTimer, setTimer } =
        useTimer();
    const { timerOverallAssessment } = useTimerValues();
    const { phase, loading, startTransition, done } = useScreenTransition();
    const { setLoading, isWarmupDoneShown, setWarmupDoneShown } =
        useContext(BaseContext);
    const timerStarted = useRef(false);
    const stepRef = useRef();
    const phrases = location.state.user.siteConfig.phrases;
    const labelText = phrases["20022499"];
    const answerData = useRef("");
    let totalQuestions = isWarmUp
        ? testData.exapmleQuestionList.length
        : testData.question.length;
    let timerLength = isWarmUp
        ? testData?.exampleTimeLimit
        : testData?.time_limit;
    useEffect(() => {
        if (totalSecLeft === -1) {
            timerStarted.current = true;
            setTimer(timerLength);
        }
        if (totalSecLeft === 0 || currQuestNo > totalQuestions - 1) {
            stopTimer();
            isWarmUp ? setWarmupDoneShown(true) : setComplete(true);
        }
        if (totalSecLeft === timerLength && keyStroke === 1) {
            startTimer(timerLength);
        }
        if (questionData) {
            stepRef.current?.children?.[1]?.children?.[0]?.setAttribute(
                "data-secLeft",
                `${min}:${sec}`
            );
        }
    }, [totalSecLeft, keyStroke]);

    useEffect(() => {
        if (isComplete) {
            setTimeout(() => {
                actionAfterTestComplete();
            }, 5000);
        }
    }, [isComplete]);

    if (!questionData) {
        return (
            <Loader
                className="align-items_start justify-content_center mt5"
                spinner
                title="Hold on a sec..."
            />
        );
    }

    const nextQuestion = () => {
        if (!loading) {
            startTransition(async () => {
                stopTimer();
                setLoading(true);
                if (!isWarmUp) getformData();
                if (isComplete || currQuestNo === questionData.length - 1) {
                    if (!isWarmUp) {
                        document.activeElement.blur();
                        setTimeout(() => {
                            actionAfterTestComplete();
                        }, 5000);

                        setCurrQuestNo(currQuestNo + 1);
                    } else if (isComplete)
                        isWarmUp ? setWarmupDoneShown(true) : navigate("/");
                    else if (isWarmUp) {
                        setWarmupDoneShown(true);
                    } else {
                        setCurrQuestNo(questionData.length);
                        setCurrentQuestion(null);
                    }
                } else {
                    document.getElementById("inputForm").reset();
                    let input = document.querySelector("#input-1");
                    input.focus();
                    setCurrentQuestion(questionData[currQuestNo + 1]);
                    setCurrQuestNo(currQuestNo + 1);
                }
                setLoading(false);
                if (keyStroke > 0) {
                    startTimer();
                }
                done();
            });
        }
    };

    const incrementCounter = () => {
        setKeyStroke(keyStroke + 1);
    };

    const getformData = () => {
        const collection = document.getElementsByClassName(
            "custom-form-input-tt28"
        );
        let tempData = "";
        for (var i = 0; i < collection.length; i++) {
            tempData += collection[i].value;
            if (i < collection.length - 1) tempData += " |";
        }
        answerData.current = answerData.current + tempData;
        if (currQuestNo < totalQuestions)
            answerData.current = answerData.current + "!";
    };

    const actionAfterTestComplete = function () {
        const elapsedTime = keyStroke === 0 ? 0 : stopTimer();
        saveAnswers(
            answerData.current,
            elapsedTime,
            testId,
            sessionId,
            keyStroke
        )
            .then((response) => {
                redirectToAssessmentSummary(location, navigate, 28);
            })
            .catch((err) => {
                console.warn("error", err);
                navigate("/" + sessionStorage.getItem("urlParams"));
            });
    };

    const closePopup = () => {
        setComplete(false);
    };

    const backtoInst = () => {
        navigate("/instructions", {
            state: { ...location.state, warmUp: false },
        });
    };

    const handleMainTestStart = () => {
        navigate("/instructions", {
            state: { ...location.state, startMainTest: true },
        });
    };

    if (isWarmupDoneShown) {
        return (
            <WarmupComplete
                backtoInst={backtoInst}
                handleMainTestStart={handleMainTestStart}
            />
        );
    }

    return (
        <div className="container bg01 roundness_1 ">
            <div className="g-container_12 flex_col g5 p4 py3_tablet px5_tablet">
                {(isComplete || currQuestNo === totalQuestions) &&
                    !isWarmUp && (
                        <CompletePopUp
                            handleClick={() => actionAfterTestComplete()}
                            phrases={phrases}
                            closePopup={closePopup}
                        />
                    )}
                <SesHeader
                    clientCobranding={location.state.cobrandingLink}
                    isWarmUp={isWarmUp}
                />
                <div
                    ref={stepRef}
                    className="top-progress-container g-item_12 g4 flex align-items_center align-self-stretch "
                >
                    <ProgressBar
                        className="full-width"
                        helper={{
                            left:
                                currQuestNo +
                                1 +
                                "/" +
                                questionData.length +
                                " " +
                                phrases?.["13106"],
                        }}
                        showPercentage={false}
                        showSteps
                        step={currQuestNo + 1}
                        steps={questionData.length}
                        title={phrases?.["14798"]}
                    />
                    <ProgressBar
                        circular
                        step={totalSecLeft}
                        steps={timerLength}
                        circularColorClass={
                            timerOverallAssessment !== undefined &&
                            totalSecLeft <= timerOverallAssessment
                                ? "progress-bar-color"
                                : ""
                        }
                    />
                </div>
                <div className="flex_col g2">
                    <h3>{testData.title}</h3>
                </div>
                {location.state.test.testType == 28 && (
                    <TestTakerQuestions28
                        dataQuestion={currentQuestion}
                        label_text={labelText}
                        isWarmUp={isWarmUp}
                        moveNextQuest={() => nextQuestion()}
                        addKeyPressed={() => incrementCounter()}
                        phrases={phrases}
                        phase={phase}
                    />
                )}
                {location.state.test.testType == 29 && (
                    <TestTakerQuestions29
                        dataQuestion={currentQuestion}
                        fullData={testData}
                        label_text={labelText}
                        isWarmUp={isWarmUp}
                        moveNextQuest={() => nextQuestion()}
                        addKeyPressed={() => incrementCounter()}
                        phrases={phrases}
                        phase={phase}
                    />
                )}
                {isWarmUp && (
                    <div className="full-width flex flex_col_mobile g2_mobile align-items_start_mobile align-items_center  align-self-stretch justify-content_end">
                        <button
                            className="button-pimary full-width_mobile"
                            onClick={() => setWarmupDoneShown(true)}
                        >
                            {phrases?.["1000252"]}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MainTestTaker28;
